import { Button, Card, Col, Input, Radio, Row, Select } from "antd"
import ControllerWarpper from "../ControllerWarpper"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faX } from "@fortawesome/free-solid-svg-icons"
import Text from "../Typography/Text"
import { useContext } from "react"
import { ModalCharterContext } from "."
import Title from "../Typography/Title"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useAirports } from "@/hooks/flight/useAirports"

export type ModalCharterRef = {
  close: () => void,
  open: () => void
}

const CharterFormInfomation = () => {
  const { getFormatCurrency, getAirportCityName } = useTETranslation()
  const { form } = useContext(ModalCharterContext)
  const { t } = useTranslation()
  const airports = useAirports()

  return (
    <Row>
      <Col span={24}>
        <ControllerWarpper
          name={"contact"}
          control={form?.control}
          style={{ marginBottom: 0 }}
          help={null}
          validateStatus=""
          label={(
            <Row wrap={false} style={{ minWidth: '100%' }} justify='space-between' align='middle' gutter={15}>
              <Col>
                <Text strong>
                  {t('booking.contact_info')}
                </Text>
              </Col>
            </Row>
          )}
          render={() => {
            return (
              <Row gutter={15}>
                <Col xs={24} lg={8}>
                  <ControllerWarpper
                    control={form?.control}
                    name={"contact.fullname"}
                    label={t("common.fullname")}
                    required
                    render={({ field }) => {
                      return (
                        <Input {...field} placeholder={t("common.fullname_placeholder")} />
                      )
                    }}
                  />
                </Col>
                <Col xs={24} md={12} lg={8}>
                  <ControllerWarpper
                    control={form?.control}
                    name={"contact.phone"}
                    label={t("common.phonenumber")}
                    required
                    render={({ field }) => {
                      return (
                        <Input {...field} placeholder={t("common.phonenumber_placeholder")} />
                      )
                    }}
                  />
                </Col>
                <Col xs={24} md={12} lg={8}>
                  <ControllerWarpper
                    control={form?.control}
                    name={"contact.email"}
                    label="Email"
                    required
                    render={({ field }) => {
                      return (
                        <Input {...field} placeholder={t("booking.email_input_placeholder")} />
                      )
                    }}
                  />
                </Col>
              </Row>
            )
          }}
        />
      </Col>
      <Col span={24}>
        <ControllerWarpper
          name="passengers"
          control={form?.control}
          help={null}
          validateStatus=""
          label={(
            <Row wrap={false} style={{ minWidth: '100%' }} justify='space-between' align='middle' gutter={15}>
              <Col>
                <Text strong>
                  {t("booking.pass_info")}
                </Text>
              </Col>
              <Col>
                <Button
                  htmlType='button'
                  type='primary'
                  icon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    const passengers = form?.getValues('passengers') || []
                    if (passengers.length >= 9) {
                      return;
                    }
                    form?.setValue('passengers', [
                      ...passengers,
                      {
                        gender: "Mr",
                        fullname: ""
                      }
                    ])
                  }}
                >
                  {`${t("common.add")} ${t("booking.passenger").toLowerCase()}`}
                </Button>
              </Col>
            </Row>
          )}

          render={({ field }) => {
            const passengers = Array.isArray(field.value) ? field.value : []
            return (
              <Row gutter={15}>
                {passengers.map((pass, idx) => {
                  return (
                    <Col xs={24} md={passengers.length === 1 ? 24 : 12}>
                      <ControllerWarpper
                        name={`passengers.${idx}`}
                        label={(
                          <Row style={{ marginBottom: 2 }}>
                            <Text type='secondary' strong>{t("booking.passenger")} {idx + 1}</Text>
                          </Row>
                        )}

                        control={form?.control}
                        render={() => {
                          return (
                            <Row gutter={5}>
                              <Col>
                                <ControllerWarpper
                                  control={form?.control}
                                  name={`passengers.${idx}.gender`}
                                  required
                                  style={{ marginBottom: 0 }}
                                  render={({ field }) => {
                                    return (
                                      <Select
                                        {...field}
                                        popupMatchSelectWidth={false}
                                        placeholder={t("common.people_title")}
                                        options={[
                                          {
                                            label: t("common.mr"),
                                            value: "Mr"
                                          },
                                          {
                                            label: t("common.mrs"),
                                            value: "Mrs"
                                          },
                                          {
                                            label: t("common.boy"),
                                            value: "boy"
                                          },
                                          {
                                            label: t("common.girl"),
                                            value: "girl"
                                          }
                                        ]}
                                      />
                                    )
                                  }}
                                />
                              </Col>
                              <Col flex={1}>
                                <ControllerWarpper
                                  control={form?.control}
                                  name={`passengers.${idx}.fullname`}
                                  required
                                  style={{ marginBottom: 0 }}
                                  render={({ field }) => {
                                    return (
                                      <Input
                                        {...field}
                                        placeholder={t("common.fullname_placeholder")}
                                      />
                                    )
                                  }}
                                />
                              </Col>
                              {passengers.length > 1 && (
                                <Col>
                                  <Button
                                    type='primary'
                                    danger
                                    icon={<FontAwesomeIcon icon={faX} />}
                                    disabled={passengers.length <= 1}
                                    onClick={() => {
                                      const newPassengers = [...passengers]
                                      delete newPassengers[idx]
                                      form?.setValue('passengers', newPassengers.filter(p => !!p))
                                    }}
                                  />
                                </Col>
                              )}
                            </Row>
                          )
                        }}
                      />

                    </Col>
                  )
                })}
              </Row>
            )
          }}
        />
      </Col>
      <Col span={24}>
        <ControllerWarpper
          name={"flight"}
          control={form?.control}
          style={{ marginBottom: 0 }}
          required
          label={(
            <Row wrap={false} style={{ minWidth: '100%' }} justify='space-between' align='middle' gutter={15}>
              <Col>
                <Text strong>
                  {t("flight.choose_flight_title")}
                </Text>
              </Col>
            </Row>
          )}
          render={({ field }) => {
            return (
              <Row>
                <Col>
                  <Radio.Group
                    {...field}
                    orientation='vertical'
                    size='large'
                  >
                    {[
                      {
                        value: "VN9082_SGNVII_19/02/2026_22:15",
                        label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['VII'])} (VN9082 - 19/02/2026 - 22h:15)`,
                      },
                      {
                        value: "VN9280_SGNVII_19/02/2026_22:15",
                        label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['VII'])} (VN9280 - 19/02/2026 - 22h:45)`
                      },
                      // {
                      //   value: "VN9100_SGNHAN_19/02/2026_04:10",
                      //   label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['HAN'])}(VN9100 - 19/02/2026 - 04h:10)`
                      // },
                      {
                        value: "VN9114_SGNHAN_20/02/2026_04:25",
                        label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['HAN'])}(VN9114 - 20/02/2026 - 04h:25)`
                      },
                      {
                        value: "VN9112_SGNHAN_20/02/2026_04:30",
                        label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['HAN'])}(VN9112 - 20/02/2026 - 04h:30)`
                      },
                      {
                        value: "VN9104_SGNHAN_20/02/2026_04:40",
                        label: `${getAirportCityName(airports['SGN'])} - ${getAirportCityName(airports['HAN'])}(VN9104 - 20/02/2026 - 04h:40)`
                      }
                    ].map((option) => {
                      return (
                        <Radio
                          value={option.value}
                        >
                          {option.label}
                        </Radio>
                      )
                    })}
                  </Radio.Group>
                </Col>
                <Col flex={1} style={{ alignSelf: 'stretch' }}>
                  <Card
                    style={{
                      height: '100%'
                    }}
                    styles={{
                      body: {
                        height: '100%'
                      }
                    }}
                    variant='outlined'
                  >
                    <Row justify='center' align='middle' style={{ height: '100%' }}>
                      <Col>
                        <Row justify='center'>
                          <Text style={{ fontSize: '3rem', textAlign: 'center' }}>Đồng giá</Text>
                        </Row>
                        <Row justify='center'>
                          <Text style={{ fontSize: '3rem', textAlign: 'center' }}><Text type='danger' strong>900K</Text>/Khách</Text>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>

              </Row>
            )
          }}
        />
      </Col>
      <Col span={24}>
        <Row gutter={15} justify='center'>
          <Col>
            <Title level={3}>{t("booking.total_amount")}:</Title>
          </Col>
          <Col>
            <Controller
              control={form?.control}
              name="passengers"
              render={({ field }) => {
                return (
                  <Title level={3} type='danger'>{getFormatCurrency(900000 * field.value.length)}</Title>
                )
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default CharterFormInfomation